import { Component, computed, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { OktaCallbackComponent } from '@okta/okta-angular';

/** Displays OAuth/OIDC redirect errors instead of an indefinite session-checking overlay. */
@Component({
  selector: 'app-oauth-callback-page',
  imports: [NgComponentOutlet],
  template: `
    @if (oauthError(); as message) {
      <section class="oauth-callback-error" role="alert" aria-live="assertive">
        <h1>OAuth authentication failed</h1>
        <p>{{ message }}</p>
        <p>Please contact your administrator if the problem continues.</p>
      </section>
    } @else {
      <ng-container *ngComponentOutlet="oktaCallbackComponent" />
    }
  `,
  styles: [`
    .oauth-callback-error { max-width: 42rem; margin: 4rem auto; padding: 2rem; border: 1px solid #a22; border-radius: .5rem; }
    .oauth-callback-error h1 { color: #a22; }
  `],
})
export class OAuthCallbackPage {
  protected readonly oktaCallbackComponent = OktaCallbackComponent;
  private readonly route = inject(ActivatedRoute);
  private readonly params = toSignal(this.route.queryParamMap, { initialValue: this.route.snapshot.queryParamMap });
  protected readonly oauthError = computed(() => {
    const params = this.params();
    const code = params.get('error');
    if (!code) return null;
    const description = params.get('error_description');
    return description ? `${code}: ${description}` : code;
  });
}
